import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '../cn.ts'

/** Ink frame with the pop-blue light source top left (§21.1). Stays ink in dark mode. */
export function Rail({ className, style, children, ...rest }: HTMLAttributes<HTMLElement>) {
  return (
    <nav
      className={cn('relative flex flex-col overflow-hidden bg-ink text-on-dark-1', className)}
      style={{
        backgroundImage:
          'radial-gradient(circle at 0 0, #3f5bffaa, transparent 65%), radial-gradient(circle at 100% 100%, #ff7a4d1f, transparent 45%)',
        borderRight: '1px solid var(--rail-divider)',
        ...style,
      }}
      {...rest}
    >
      {children}
    </nav>
  )
}

export interface RailItemProps extends HTMLAttributes<HTMLSpanElement> {
  icon: ReactNode
  label: string
  active?: boolean
  badge?: ReactNode
}

/** Visual rail entry; wrap it in a router link. */
export function RailItem({ icon, label, active, badge, className, ...rest }: RailItemProps) {
  return (
    <span
      title={label}
      className={cn(
        'relative flex size-10 items-center justify-center rounded-tile transition-colors duration-150 ease-out',
        active ? 'bg-white/12 text-white' : 'text-on-dark-3 hover:bg-white/8 hover:text-white',
        className,
      )}
      {...rest}
    >
      {icon}
      <span className="sr-only">{label}</span>
      {badge != null && (
        <span className="absolute -top-0.5 -right-0.5 flex h-4 min-w-4 items-center justify-center rounded-pill bg-apricot px-1 font-medium text-[10px] text-ink">
          {badge}
        </span>
      )}
    </span>
  )
}
